/**
 * @generated SignedSource<<2a5834e5167e4cb394590372eea2156a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TradeSubscriptionsBookSubscription$variables = {
  id: string;
};
export type TradeSubscriptionsBookSubscription$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"OrderBookSubFragment">;
  } | null | undefined;
};
export type TradeSubscriptionsBookSubscription = {
  response: TradeSubscriptionsBookSubscription$data;
  variables: TradeSubscriptionsBookSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "value",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "price",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "total",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "virtualTotal",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "virtualValue",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "side",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TradeSubscriptionsBookSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "OrderBookSubFragment"
              }
            ],
            "type": "FinBook",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootSubscriptionType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TradeSubscriptionsBookSubscription",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "center",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spread",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinBookEntry",
                "kind": "LinkedField",
                "name": "bids",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "FinBookEntry",
                "kind": "LinkedField",
                "name": "asks",
                "plural": true,
                "selections": (v2/*: any*/),
                "storageKey": null
              }
            ],
            "type": "FinBook",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3e519049f18252a46250e47d77a37eb2",
    "id": null,
    "metadata": {},
    "name": "TradeSubscriptionsBookSubscription",
    "operationKind": "subscription",
    "text": "subscription TradeSubscriptionsBookSubscription(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on FinBook {\n      ...OrderBookSubFragment\n    }\n    id\n  }\n}\n\nfragment OrderBookEntryFragment on FinBookEntry {\n  price\n  side\n  total\n  value\n  virtualTotal\n  virtualValue\n}\n\nfragment OrderBookSubFragment on FinBook {\n  id\n  center\n  spread\n  bids {\n    value\n    price\n    total\n    virtualTotal\n    virtualValue\n    ...OrderBookEntryFragment\n  }\n  asks {\n    value\n    price\n    total\n    virtualTotal\n    virtualValue\n    ...OrderBookEntryFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab48d45c9e83ac303e73c2b64c9ff641";

export default node;
